import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NavComponent } from './nav/nav.component'
import { AboutComponent } from './about/about.component'
import { MainComponent } from './main/main.component'
import { DetailsComponent } from './details/details.component'

const routes: Routes = [
  {path: '', component: MainComponent },
  {path: 'details/:id', component: MainComponent }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
